import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { ContratoChipInterface } from 'app/module/contrato-chip-interface';

@Injectable({
	providedIn: 'root'
})
export class ContratoChipService {
	private url: string = environment.g2e_api;

	private httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json; charset=UTF-8',
			'Authorization': 'Bearer ' + localStorage.getItem("tokenApiG2E")
		}),
	}

	constructor(private http: HttpClient) { }

	public getByContratoId(id): Observable<ContratoChipInterface[]> {
		return this.http.get<ContratoChipInterface[]>(`${this.url}contrato-chip/contrato/${id}`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	public getByContratoItemId(id): Observable<ContratoChipInterface[]> {
		return this.http.get<ContratoChipInterface[]>(`${this.url}contrato-chip/contrato-item/${id}`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}
}
